var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-table-item"},[_c('span',{staticClass:"name",staticStyle:{"padding":"12px 0"}},[_vm._v(_vm._s(_vm.name)+":")]),_c('span',{staticClass:"param"},[_vm._v(_vm._s(_vm.param))])])}
var staticRenderFns = []

export { render, staticRenderFns }